import { render, staticRenderFns } from "./editBackUser.vue?vue&type=template&id=71c9cc86&scoped=true&"
import script from "./editBackUser.vue?vue&type=script&lang=js&"
export * from "./editBackUser.vue?vue&type=script&lang=js&"
import style0 from "./editBackUser.vue?vue&type=style&index=0&id=71c9cc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9cc86",
  null
  
)

export default component.exports